var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre-survey-form',{attrs:{"is-submitting-form":_vm.isSubmittingForm,"survey-id":_vm.surveyId},on:{"submit":_vm.onSubmit,"automatic-submit":_vm.onAutomaticSubmit}},[_c('CloudflareTurnstileWidget',{attrs:{"theme":"auto"},on:{"success":_vm.handleTurnstileSuccess,"expired":_vm.handleTurnstileTokenExpired}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }